import React from 'react';
import { ShieldCheck, Target, HeartHandshake } from 'lucide-react';

const items = [
  { icon: Target, title: 'Gerçekçi Deneyim', desc: 'Sınırları zorlayan, detaylara önem veren ve oyunculara gerçekçi bir askeri atmosfer sunan projeler.', grad: 'from-blue-400/30 to-indigo-500/30' },
  { icon: ShieldCheck, title: 'Disiplin ve Düzen', desc: 'Gelişmiş hiyerarşi ve sistemlerle, roleplay standartlarını en üst düzeye çıkarıyoruz.', grad: 'from-rose-400/30 to-red-500/30' },
  { icon: HeartHandshake, title: 'Güçlü Topluluk', desc: 'Birliktelik ve kardeşlik duygusuyla büyüyen, her an destekleyici bir aile ortamı.', grad: 'from-emerald-400/30 to-teal-500/30' },
];

export default function WhoWeAre() {
  return (
    <section id="about" className="py-24 relative overflow-hidden">
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative z-10">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-rose-500/20 bg-rose-500/10 text-rose-400 text-xs font-bold uppercase tracking-widest mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" />
            Hakkımızda
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4">Biz Kimiz?</h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            2022'den bu yana Roblox platformunda Türkiye'nin en kaliteli askeri simülasyon deneyimlerini inşa eden, 
            topluluğuyla omuz omuza büyüyen köklü bir stüdyo.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {items.map((it) => (
            <div key={it.title} className="bg-slate-900/40 backdrop-blur-md border border-slate-800 rounded-3xl p-8 hover:-translate-y-2 transition-all duration-500 group relative overflow-hidden shadow-2xl">
              <div className={`absolute -top-24 -right-24 w-48 h-48 rounded-full bg-gradient-to-br ${it.grad} blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700`} />
              <div className="relative z-10">
                <div className="w-14 h-14 rounded-2xl bg-slate-800/80 border border-slate-700 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500 shadow-xl">
                  <it.icon size={24} className="text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{it.title}</h3>
                <p className="text-slate-400 leading-relaxed">{it.desc}</p>
              </div>
              <div className="absolute inset-0 border border-white/5 rounded-3xl pointer-events-none group-hover:border-white/10 transition-colors duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
